import { render, staticRenderFns } from "./activity-management-v2.vue?vue&type=template&id=28de1271&"
import script from "./activity-management-v2.vue?vue&type=script&lang=ts&"
export * from "./activity-management-v2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports